import * as React from 'react';
import { SVGProps } from 'react';

const IconAddToComparisonSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 1h1v10H1V1zm7 0h1v2h2v1H9v2H8V4H6V3h2V1zM5 5h1v6H5V5zm2 2h1v4H7V7zm3 2H9v2h1V9zM4 3H3v8h1V3z" />
  </svg>
);
export default IconAddToComparisonSizeXs;
